import { render, staticRenderFns } from "./ProjectSummaryCompleted.vue?vue&type=template&id=c0f60276&"
import script from "./ProjectSummaryCompleted.vue?vue&type=script&lang=js&"
export * from "./ProjectSummaryCompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports